import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/Button/Button';
import GenericCard from '../../../components/GenericCards/GenericCards';
import useMobile from '../../../hooks/useMobileHook';

const Tools = ({
  transperant = false,
  coveredFamilyMembers,
  isWaived = false,
  linksData,
}: any) => {
  const isMobile = useMobile();
  const navigate = useNavigate();

  return (
    <Row className="m-0 p-0 d-flex justify-content-between">
      

      <Container className={`p-0 ${transperant && 'border rounded-1'}`}>
        <GenericCard variant={`${transperant ? 'transperant' : 'white'}`}>
          <Row className="m-0 px-6 px-lg-0">
            
            {/*<div className="col-12 col-md-6">
                <div className="card mb-10 border-0 border-bottom border-radius-0">
                    <div className="card-body p-0">
                        <div className="card-title fw-bold nav-link-text text-sub2"><a href="https://www.mybenefitwallet.com/" target="_blank" className="text-decoration-none">BenefitWallet</a></div>
                        <p className="card-subtitle mb-2 text-muted lh-xxs fw-light text-sub1 text-size-12">Link to Self-Service Employer Portal for BenefitWallet</p>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="card mb-10 border-0 border-bottom border-radius-0">
                    <div className="card-body p-0">
                        <div className="card-title fw-bold nav-link-text text-sub2"><a href="https://oneportal.uxgroup.com/LW60/AccessPoint/healthy401k.html" target="_blank" className="text-decoration-none">DailyVest/Healthy 401k</a></div>
                        <p className="card-subtitle mb-2 text-muted lh-xxs fw-light text-sub1 text-size-12">SSO to DailyVest Healthy 401K 3rd party application</p>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="card mb-10 border-0 border-bottom border-radius-0">
                    <div className="card-body p-0">
                        <div className="card-title fw-bold nav-link-text text-sub2"><a href="https://oneportal.uxgroup.com/LW60/AccessPoint/focusAnalytics3.html" target="_blank" className="text-decoration-none">Focus Analytics</a></div>
                        <p className="card-subtitle mb-2 text-muted lh-xxs fw-light text-sub1 text-size-12">Link to Focus Analytics page</p>
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="card mb-10 border-0 border-bottom border-radius-0">
                    <div className="card-body p-0">
                        <div className="card-title fw-bold nav-link-text text-sub2"><a href="https://oneportal.uxgroup.com/LW60/AccessPoint/healthAct.html" target="_blank" className="text-decoration-none">HealthAct Admin Portal</a></div>
                        <p className="card-subtitle mb-2 text-muted lh-xxs fw-light text-sub1 text-size-12">Link to HealthAct Administrative Portal sign on page</p>
                    </div>
                </div>
            </div>*/}
        
            <div className="col-12 col-md-6">
                <div className="card mb-10 border-0 border-bottom border-radius-0">
                    <div className="card-body p-0">
                        <div className="card-title fw-bold nav-link-text text-sub2"><a href="https://oneportal.uxgroup.com/LW60/AccessPoint/kAccess_Home.html" target="_blank" className="text-decoration-none">Knowledge Access</a></div>
                        <p className="card-subtitle mb-2 text-muted lh-xxs fw-light text-sub1 text-size-12">SSO to KAccess for External users</p>
                    </div>
                </div>
            </div>
            {/*<div className="col-12 col-md-6">
                <div className="card mb-10 border-0 border-bottom border-radius-0">
                    <div className="card-body p-0">
                        <div className="card-title fw-bold nav-link-text text-sub2"><a href="https://oneportal.uxgroup.com/LW60/AccessPoint/onDemandReporting.html" target="_blank" className="text-decoration-none">On Demand Reporting</a></div>
                        <p className="card-subtitle mb-2 text-muted lh-xxs fw-light text-sub1 text-size-12">Link to Cognos On Demand Reporting sign on page</p>
                    </div>
                </div>
            </div>*/}
            <div className="col-12 col-md-6">
                <div className="card mb-10 border-0 border-bottom border-radius-0">
                    <div className="card-body p-0">
                        <div className="card-title fw-bold nav-link-text text-sub2"><a href="https://oneportal.uxgroup.com/LW60/AccessPoint/DBAdmin/DBAdmin01.html" target="_blank" className="text-decoration-none">Defined Benefits Admin Portal</a></div>
                        <p className="card-subtitle mb-2 text-muted lh-xxs fw-light text-sub1 text-size-12">Multi-Tenant Admin System</p>
                    </div>
                </div>
            </div>
            
                   
          </Row>
        </GenericCard>
      </Container>
    </Row>
  );
};

export default Tools;
